module.exports = __webpack_public_path__ + "img/avris-logo-white-LR.6edc427f.png";